import axios from "axios";
import API_BASE_URL from "@/config/api";

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
  },

  mutations: {
    SET_LIST(state, data) {
      state.list = data;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
  },

  actions: {
    // 🟢 Ajouter une recette
    async add({ dispatch }, income) {
      await this._vm.$guard.confirmAndExecute({
        message: "Ajouter cette recette ?",
        action: async () => {
          const record = {
            ...income,
            date: income.date || new Date().toISOString().split('T')[0],
            created_at: new Date().toISOString(),
          };
          await axios.post(`${API_BASE_URL}/income.php`, record);
          await dispatch("fetch");
        },
      });
    },

    // 🔵 Récupérer toutes les recettes
    async fetch({ commit }) {
      commit("SET_LOADING", true);
      try {
        const { data } = await axios.get(`${API_BASE_URL}/income.php`);
        commit("SET_LIST", data);
      } catch (err) {
        console.error("Erreur fetch income:", err);
      }
      commit("SET_LOADING", false);
    },

    // 🟠 Modifier une recette
    async update({ dispatch }, { id, payload }) {
      await this._vm.$guard.confirmAndExecute({
        message: "Modifier cette recette ?",
        action: async () => {
          await axios.put(`${API_BASE_URL}/income.php`, { id, ...payload });
          await dispatch("fetch");
        },
      });
    },

    // 🔴 Supprimer une recette
    async remove({ dispatch }, id) {
      await this._vm.$guard.confirmAndExecute({
        message: "Supprimer cette recette ?",
        action: async () => {
          await axios.delete(`${API_BASE_URL}/income.php`, { data: { id } });
          await dispatch("fetch");
        },
      });
    },

    // ⚪ Vider toutes les recettes
    async clear({ dispatch }) {
      await this._vm.$guard.confirmAndExecute({
        message: "Effacer toutes les recettes ?",
        action: async () => {
          await axios.post(`${API_BASE_URL}/income.php`, { action: "clear" });
          await dispatch("fetch");
        },
      });
    },
  },

  getters: {
    all: (state) => state.list,
    totalAmount: (state) =>
      state.list.reduce((sum, i) => sum + Number(i.amount || 0), 0),
    isLoading: (state) => state.loading,
  },
};
